import {Component, EventEmitter, Output, ViewEncapsulation} from '@angular/core';
import {MessageService} from 'primeng/api';

import {Person} from '../model';
import {KeyholdersListComponent} from '../entity-component/keyholders-list.component';
import {CommService} from '../services/comm.service';
import {tokenHasRole} from '../services/jwt.service';

@Component( {
    selector: 'persons-list',
    templateUrl: './persons-list.component.html',
    styleUrls: ['./persons-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
} )
export class PersonsListComponent extends KeyholdersListComponent<Person> {

    @Output()
    public download = new EventEmitter();

    constructor(
        private commService: CommService,
        private messageService: MessageService
    ) {
        super();
    }

    protected getEditItemPath(): string {
        return '/edit-person';
    }

    public getBadgeStatus( item: Person ) {
        return ( !!item && !!item.properties && -1 != Object.keys( item.properties ).indexOf( "PERSON_BADGE_STATUS" ) )
            ? item.properties["PERSON_BADGE_STATUS"] : undefined;
    }

    public isAdmin(): boolean {
        return tokenHasRole('Administrators');
    }

    public async openPersonPage(event: Event, person: Person): Promise<void> {
        event.stopPropagation();
        const badgeId = person.keyRFID;
        if (!badgeId) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Not Available',
                detail: 'This person has no badge assigned.',
                life: 5000
            });
            return;
        }
        try {
            const url = await this.commService.getDriverUrl(badgeId);
            if (!url) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Not Available',
                    detail: 'This person has not visited the airport during the last 8 hours.',
                    life: 5000
                });
            } else {
                window.open(url, '_blank');
            }
        } catch (error) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to retrieve person page URL.',
                life: 5000
            });
        }
    }
}
